export default {
  setFissionData(state, data) {
    this.commit('SETFISSIONDATA', data)
  },
  setLoginStatus(state, data) {
    this.commit('SETLOGINSTATUS', data)
  },
  fissionIsLoginCheck(state, data) {
    this.commit('FISSIONLOGINCHECK', data)
  },

  // 促转化start
  setConversionData(state, data) {
    this.commit('SETCONVERSIONDATA', data)
  },
  setConversionLoginStatus(state, data) {
    this.commit('SETCONVERSIONLOGINSTATUS', data)
  },
  setConversionHasLogin(state, data) {
    this.commit('SETCONVERSIONHASLOGIN', data)
  }
}
